import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { NgxSpinnerService } from 'ngx-spinner';
import { Classificacao } from 'src/app/models/classificacao';
import { Segmentacao } from 'src/app/models/segmentacao';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { SegmentacaoService } from 'src/app/services/segmentacao.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { CadastrarPontosFidelidadeModalComponent } from '../../pontos-fidelidade-modal/cadastrar-pontos-fidelidade-modal/cadastrar-pontos-fidelidade-modal.component';

@Component({
  selector: 'app-cadastrar-classificacao-modal',
  templateUrl: './cadastrar-classificacao-modal.component.html',
  styleUrls: ['./cadastrar-classificacao-modal.component.scss']
})
export class CadastrarClassificacaoModalComponent implements OnInit {
  idClassificacao;
  classificacao: Segmentacao;
  public config: PerfectScrollbarConfigInterface = {};
  administrador = false;
  carregando = true;
  editando = false;

  @ViewChild('matImage', { static: false }) matImage: ElementRef;
  selectedFile: File;

  constructor(
    public dialogRef: MatDialogRef<CadastrarPontosFidelidadeModalComponent>,
    private globalService: GlobalService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notificacaoService: NotificacaoService,
    private segmentacaoService: SegmentacaoService,
    private carregandoService: CarregandoService,
    private utilitarioService: UtilitarioService
  ) {
    this.idClassificacao = data.idClassificacao;
  }

  async ngOnInit() {
    this.administrador = await this.globalService.administrador();
    if (this.idClassificacao) {
      this.editando = true;
      this.buscarClassificacao();
    } else {
      this.classificacao = new Segmentacao();
    }
  }

  async salvar() {
    if (this.classificacao.descFrete !== null && this.classificacao.descFrete !== undefined) {
      this.classificacao.descFrete = Number(this.classificacao.descFrete);
    }

    if (this.selectedFile) {
      this.classificacao.imagem = (await this.utilitarioService.toBase64(this.selectedFile));
    }

    this.carregandoService.mostra('salvarClassificacao');
    this.segmentacaoService.salvar(this.classificacao).subscribe((retorno) => {
      this.notificacaoService.sucesso('Classificação salva com sucesso!!!');
      this.carregandoService.esconde('salvarClassificacao');
      this.dialogRef.close(true);
    }, (erro) => {
      this.carregandoService.esconde('salvarClassificacao');
      this.notificacaoService.erro(erro);
    });
  }

  fechar() {
    this.dialogRef.close();
  }

  buscarClassificacao() {
    this.carregandoService.mostra('buscarClassificacao');

    this.segmentacaoService.consultarPorId(this.idClassificacao).subscribe((data: any) => {
      this.classificacao = data;
      this.carregando = false;
      this.carregandoService.esconde('buscarClassificacao');
    }, (erro) => {
      this.carregandoService.esconde('buscarClassificacao');
      this.notificacaoService.erro(erro);
    });
  }

  validar() {
    return this.classificacao.descricao !== null && this.classificacao.descricao !== undefined;
  }

  onFileChanged(event) {
    if (event.target.files[0].type !== 'image/jpeg') {
      this.matImage.nativeElement.value = null;

      this.notificacaoService.erroMSG('Arquivo inválido, use arquivos com extensão .jpg');
      return;
    } else {
      this.classificacao.imagem = '';
      this.selectedFile = event.target.files[0];
    }

    const maxSize = 50 * 190;

    if (event.target.files[0].size > maxSize) {
      alert("O arquivo deve ter no máximo 500KB!");
      return;
  }
  }

  excluirArquivo() {
    this.classificacao.imagem = '';
    this.selectedFile = undefined;
  }
}
